import GuideLayout, { GuideStep } from './GuideLayout';

const nakliyeSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın ve hesabınıza giriş yapın.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'Nakliye Seçin', description: 'Ana ekranda "Nakliye" hizmetine tıklayın. Ev ve ofis taşıma için ideal.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Adres Girin', description: 'Alınacak ve teslim edilecek adresleri detaylı girin.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Eşya Bilgisi', description: 'Taşınacak eşyaların listesini ve özel durumları belirtin.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyat Teklifi', description: 'Nakliye için fiyat teklifi alın ve onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Randevu Seçin', description: 'Nakliye için uygun tarih ve saat aralığı seçin.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'Güvenli ödeme seçenekleriyle ödemenizi tamamlayın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Ekibi Takip', description: 'Nakliye ekibini haritada canlı takip edin.', image: '/images/customer-app/8.png' },
];

export default function NakliyeGuidePage() {
  return (
    <GuideLayout
      service="nakliye"
      poster={{ src: '/images/services/nakliye.jpg', alt: 'Nakliye hizmeti tanıtımı' }}
      seo={{
        title: 'Nakliye Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO ile nakliye talebi nasıl oluşturulur? 8 adımda ev ve ofis taşıma hizmeti alın.',
        keywords: ['nakliye talebi', 'ev taşıma', 'ofis taşıma', 'eşya nakliyesi'],
      }}
      breadcrumb="Nakliye"
      title="Nakliye Talebi Nasıl Oluşturulur?"
      subtitle="8 kolay adımda nakliye hizmeti alın. Ev ve ofis taşımalarınız güvende!"
      accent={{
        from: '#d97706',
        to: '#b45309',
        soft: '#fef3c7',
        border: '#fcd34d',
        strong: '#92400e',
        text: '#78350f',
      }}
      steps={nakliyeSteps}
      tipsTitle="Nakliye Hizmeti İpuçları"
      tips={[
        'Kırılacak eşyaları (cam, porselen vb.) önceden paketleyin veya belirtin.',
        'Asansör durumunu ve kat bilgisini doğru girin, fiyatı etkiler.',
        'Büyük mobilyalar için demontaj gerekip gerekmediğini belirtin.',
        'Taşınma günü için önceden randevu almanızı öneririz.',
      ]}
      cta={{
        title: 'Hemen Nakliye Talebi Oluşturun!',
        text: 'Ev veya ofis mi taşıyorsunuz? Profesyonel nakliye hizmeti alın.',
        label: 'Nakliye Talebi Oluştur',
        href: 'https://yolsepetigo.com',
        tone: 'primary',
      }}
    />
  );
}
